import { Model } from '../contract/Models';
import { NotificationId } from '../contract/Notifications';
import { VerbId } from '../contract/Verbs';
import { VersionNumber } from './VersionNumber';

export type NotificationHandler = (notification: Notification) => void;

export interface ExecuteParameters {
  [key: string]: Model;
}

export interface ExecuteResponse {
  result: Model;
}

export interface Notification {
  notificationId: NotificationId;
  data: Model;
}

export interface InternalApiDispatcher {
  execute(verb: VerbId, parameters: ExecuteParameters): Promise<ExecuteResponse>;
  registerNotificationHandler(handler: NotificationHandler): void;
  unregisterNotificationHandler(handler: NotificationHandler): void;
}

// This factory function will get called from the external side of things to instantiate a properly
// versioned API dispatcher which this particular version of external knows how to use
export type InternalApiDispatcherFactory =
  (internalContractVersion: VersionNumber) => InternalApiDispatcher;

declare global {
  interface Window { __tableauDesktopDispatcher: Promise<InternalApiDispatcherFactory>; }
}

export namespace InternalApiDispatcherHolder {
  export function getDesktopDispatcherPromise(): Promise<InternalApiDispatcherFactory> {
    return window.__tableauDesktopDispatcher;
  }

  export function hasDesktopApiDispatcherPromise(): boolean {
    return !!InternalApiDispatcherHolder.getDesktopDispatcherPromise();
  }

  export function setDesktopDispatcherPromise(dispatcher: Promise<InternalApiDispatcherFactory>): void {
    window.__tableauDesktopDispatcher = dispatcher;
  }
}



// WEBPACK FOOTER //
// ../../../src/interface/InternalApiDispatcher.ts


// WEBPACK FOOTER //
// webpack:///src/interface/InternalApiDispatcher.ts